import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=dbb7c15e&scoped=true&"
import script from "./PreviewHeader.vue?vue&type=script&lang=ts&"
export * from "./PreviewHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewHeader.vue?vue&type=style&index=0&id=dbb7c15e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb7c15e",
  null
  
)

export default component.exports